import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { Config } from '../.env.js';
import "./style.css";
import languageOptions from "./languageOptions.json";
import PersonalDetailsUser from './orderFormComponent/PersonalDetailsUser.js';
import Header from './Header.js';
import Footer from './Footer.js';

const AdminForm = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const campaignName = queryParams.get('campaignName');
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [selectedProducts, setSelectedProducts] = useState([]);


    const [showMessage, setShowMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([{ name: '', quantity: '', ss: null, amount: '' }]);
    const [errors, setErrors] = useState({
        BeneficiaryName: '',
        BankName: '',
        ifsc: '',
        pinCode: '',
        FullName: '',
        city: '',
        collegeName: '',
    });
    const initialFormState = {
        FullName: '',
        review: '',
        customMarketPlaceName: '',
        customForoum: '',
        whatsappGroup: '',
        city: '',
        state: '',
        AuthInstagram: '',
        AuthFacebook: '',
        AuthTwitter: '',
        AuthYouTube: '',
        gender: '',
        langaugeWrite: '',
        langaugeSpeek: '',
        collegeName: '',
        whatsapp: '',
        email: '',
        date: '',
        manager: '',
        pinCode: '',
        accountNumber: '',
        ifsc: '',
        BeneficiaryName: '',
        BankName: '',
        productName: '',
        productSS: '',
        inputValue: '',
        quantity: '',
        productAmount: '',
        inputValue3: '',
        inputValue4: '',
        order: '',
        Phone: '',
        student: '',
        customSocial: '',
        profileType: '',
        submitedDate: '',
        campaignName: '',
        url: '',
    };

    const [formData, setFormData] = useState(() => {
        // Load saved data from localStorage if available

        console.log("User ID:", localStorage.getItem("loggedInUserId"));
        const savedData = localStorage.getItem('formData');
        return savedData ? JSON.parse(savedData) : initialFormState;
    });
    useEffect(() => {
        localStorage.setItem('formData', JSON.stringify(formData));
    }, [formData]);

    // const handleClearStorage = () => {
    //     localStorage.clear();
    //     setFormData({
    //         FullName: '',
    //         review: '',
    //         customMarketPlaceName: '',
    //         customForoum: '',
    //         whatsappGroup: '',
    //         city: '',
    //         state: '',
    //         instagram: '',
    //         facebook: '',
    //         twitter: '',
    //         youTube: '',
    //         gender: '',
    //         upi: '',
    //         langaugeWrite: '',
    //         langaugeSpeek: '',
    //         collegeName: '',
    //         whatsapp: '',
    //         email: '',
    //         date: '',
    //         manager: '',
    //         pinCode: '',
    //         accountNumber: '',
    //         ifsc: '',
    //         BeneficiaryName: '',
    //         BankName: '',
    //         productName: '',
    //         productSS: '',
    //         inputValue: '',
    //         inputValue1: '',
    //         quantity: '',
    //         productAmount: '',
    //         inputValue3: '',
    //         inputValue4: '',
    //         order: '',
    //         Phone: '',
    //         student: '',
    //         AuthCustomSocial: '',
    //         profileType: '',
    //         submitedDate: '',
    //         campaignName: '',
    //     });
    // };
    const handleClearStorage = () => {
        localStorage.removeItem('formData'); // ❌ Don't clear entire localStorage
        setFormData({ ...initialFormState }); // ✅ Reset form only
    };
    useEffect(() => {
        if (campaignName) {
            console.log(campaignName)
            const fetchData = async () => {
                try {
                    console.log(`Fetching: ${Config.API_URL}/api/formdata/${campaignName}`);
                    const response = await axios.get(`${Config.API_URL}/api/formdata/${campaignName}`);
                    console.log('Fetched data:', response.data);

                    if (!response.data || response.data.length === 0) {
                        console.warn('No data found for this campaign.');
                        return;
                    }

                    const filteredData = response.data.reduce((acc, item) => ({ ...acc, ...item }), {});
                    setData(filteredData);
                } catch (error) {
                    console.error('Error fetching form data:', error);
                }
            };
            fetchData();
        }
    }, [campaignName]);

    // const handleCancel = () => {
    //     localStorage.clear();
    //     window.location.reload();  // Ensure fresh state
    // };
    const handleCancel = () => {
        localStorage.removeItem('formData'); // Clear only form data
        setFormData({ ...initialFormState }); // Reset to defaults
        window.location.reload();
    };

    // const handleFormChange = (event) => {
    //   const { name, value, type, checked } = event.target;

    //   setFormData(prevData => ({
    //     ...prevData,
    //     [name]: type === 'checkbox' ? checked : value,
    //   }));
    // };
    const handleFormChange = (eventOrValue, actionMeta) => {
        // Check if this is the Select component's event
        if (Array.isArray(eventOrValue)) {
            const { name } = actionMeta; // Get the 'name' of the Select input
            setFormData(prevData => ({
                ...prevData,
                [name]: eventOrValue, // Update with the selected options array
            }));
        } else {

            // Handle regular inputs
            const { name, value, type, checked } = eventOrValue.target;
            if (name === "BeneficiaryName") {
                const regex = /^[A-Za-z\s]*$/;
                if (!regex.test(value)) {
                    setErrors((prev) => ({
                        ...prev,
                        BeneficiaryName: 'Only letters and spaces are allowed.',
                    }));
                    return;
                } else {
                    setErrors((prev) => ({
                        ...prev,
                        BeneficiaryName: '',
                    }));
                }
            }
            if (name === "BankName") {
                const regex = /^[A-Za-z\s]*$/;
                if (!regex.test(value)) {
                    setErrors((prev) => ({
                        ...prev,
                        BankName: 'Only letters and spaces are allowed.',
                    }));
                    return;
                } else {
                    setErrors((prev) => ({
                        ...prev,
                        BankName: '',
                    }));
                }
            }
            if (name === "FullName") {
                const regex = /^[A-Za-z\s]*$/;
                if (!regex.test(value)) {
                    setErrors((prev) => ({
                        ...prev,
                        FullName: 'Only letters and spaces are allowed.',
                    }));
                    return;
                } else {
                    setErrors((prev) => ({
                        ...prev,
                        FullName: '',
                    }));
                }
            }
            if (name === "city") {
                const regex = /^[A-Za-z\s]*$/;
                if (!regex.test(value)) {
                    setErrors((prev) => ({
                        ...prev,
                        city: 'Only letters and spaces are allowed.',
                    }));
                    return;
                } else {
                    setErrors((prev) => ({
                        ...prev,
                        city: '',
                    }));
                }
            }
            if (name === "collegeName") {
                const regex = /^[A-Za-z\s]*$/;
                if (!regex.test(value)) {
                    setErrors((prev) => ({
                        ...prev,
                        collegeName: 'Only letters and spaces are allowed.',
                    }));
                    return;
                } else {
                    setErrors((prev) => ({
                        ...prev,
                        collegeName: '',
                    }));
                }
            }
            if (name === "ifsc") {
                const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/i;
                if (value.length > 11) return; // restrict max characters
                if (!ifscRegex.test(value) && value.length === 11) {
                    setErrors((prev) => ({
                        ...prev,
                        ifsc: 'Invalid IFSC Code format. Example: HDFC0001234',
                    }));
                } else {
                    setErrors((prev) => ({
                        ...prev,
                        ifsc: '',
                    }));
                }
            }
            if (name === "pinCode") {
                // Allow typing any digits up to 6
                if (!/^\d{0,6}$/.test(value)) return;

                setFormData((prev) => ({ ...prev, [name]: value }));

                // Show error only when full 6-digit value is present
                if (value.length === 6 && value === "000000") {
                    setErrors((prev) => ({
                        ...prev,
                        pinCode: "000000 is not a valid pincode.",
                    }));
                } else {
                    setErrors((prev) => ({
                        ...prev,
                        pinCode: "",
                    }));
                }
                return;
            }

            setFormData(prevData => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowMessage(true);
        setLoading(true);
        //const loggedInUserId = localStorage.getItem("loggedInUserId");
        const formDataToSubmit = {
            ...formData,
            student: formData.student === true, // Ensure it's a boolean
            campaignName,
            url: window.location.href,
            userId: localStorage.getItem("loggedInUserId"),
        };
        console.log("User ID:", localStorage.getItem("loggedInUserId"));

        try {
            const response = await axios.post(`${Config.API_URL}/api/order-data`, formDataToSubmit);
            console.log('Data saved:', response.data);

            // Optionally navigate after a successful submission
            setTimeout(() => {
                navigate('/live-user');
            }, 1500);
        } catch (error) {
            console.error('Error saving data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(`${Config.API_URL}/api/product`, {
                    params: { campaignName }, // Send campaign name as a query parameter
                });
                setProducts(response.data); // Set fetched products to state
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };

        if (campaignName) {
            fetchProducts(); // Fetch products when campaignName changes
        }
    }, [campaignName]);
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            // You can handle file processing or uploading logic here
            // For example, you can save the file to state or send it to a server
            console.log(file);
        }
    };
    const hasValNumber = /^[6-9]\d{9}$/.test(formData.Phone);

    let hasValWhatsapp = /^(\+?\d{1, 3})? ?\d{10}$/.test(formData.whatsapp);
    //let hasValEmail = /^[a.-zA.-Z0.-9]+@[a.-zA.-Z0.-9]+\.[A-Za-z]+$/.test(formData.email);
    const hasValEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/.test(formData.email);

    //const validOrderId = /^[a-zA-Z0-9]*$/.test(formData.order);
    // Inside component body, before return
    const validOrderId = /^[a-zA-Z0-9]+$/.test(formData.order);


    const customStyles1 = {
        control: (provided) => ({
            ...provided,

        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: '20px',
        }),
        option: (provided, state) => ({
            ...provided,
            borderRadius: state.isFocused ? '20px' : '0',
        }),
        multiValue: (provided) => ({
            ...provided,
            borderRadius: '20px',
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            borderRadius: '20px',
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            borderRadius: '20px',
        }),
    };
    return (
        <>

            <div className='card' style={{ width: "1248px", left: "35px", right: "40px" }}>
                {loading && (
                    <div className="loader-overlay">
                        <div className="loader"></div>
                    </div>
                )}
                <form onSubmit={handleSubmit}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <h2 style={{ fontFamily: "Roboto", fontWeight: "600", width: "374px", marginTop: "75px", marginLeft: "155px" }}>
                            Campaign Participation Form
                        </h2>
                    </div>
                    <div style={{ marginLeft: "49px", marginRight: "25px" }}>
                        <h2 style={{ fontFamily: "Roboto", fontWeight: "500", width: "259px", marginTop: "40px" }}>
                            Instructions Before Filling the Form:
                        </h2>
                        <h2 style={{ fontFamily: "Roboto", fontWeight: "500", maxWidth: "1059px", fontSize: "12px", marginTop: "10px" }}>
                            Please fill out all required field1s carefully and ensure that your contact, order, and payment details are accurate. Incomplete or incorrect submissions may be rejected. By submitting this form, you confirm that you agree to the terms and conditions of the campaign.
                        </h2>
                    </div>
                    {/* 👇 Wrap field1s in a 3-column layout */}
                    <div style={{ marginLeft: "25px", marginRight: "25px" }}>
                        <div style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gap: "15px",
                            marginTop: "20px",
                            marginLeft: "25px"

                        }}>
                            {data.FullName === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "raleway", fontWeight: "500", fontSize: "13px", height: "23px" }}>Your Full Name</label>
                                    <div className="control">
                                        <input className="input " type="text" name="FullName" placeholder="Name" value={formData.FullName} onChange={handleFormChange} maxLength={50} required />
                                    </div>
                                    {errors.FullName && (
                                        <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                            {errors.FullName}
                                        </p>
                                    )}
                                </div>
                            )}

                            {data.instagram === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Your Instagram User Name</label>
                                    <div className="control">
                                        <input className="input " type="text" name="AuthInstagram" placeholder="Username" value={formData.instagram} onChange={handleFormChange} required />
                                    </div>
                                </div>
                            )}

                            {data.youTube === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Your YouTube User Name</label>
                                    <div className="control">
                                        <input className="input " type="text" name="AuthYouTube" placeholder="Username" value={formData.youTube} onChange={handleFormChange} required />
                                    </div>
                                </div>
                            )}

                            {data.twitter === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Your Twitter User Name</label>
                                    <div className="control">
                                        <input className="input " type="text" name="AuthTwitter" placeholder="Username" value={formData.twitter} onChange={handleFormChange} required />
                                    </div>
                                </div>
                            )}

                            {data.facebook === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Your Facebook User Name</label>
                                    <div className="control">
                                        <input className="input " type="text" name="AuthFacebook" placeholder="Username" value={formData.facebook} onChange={handleFormChange} required />
                                    </div>
                                </div>
                            )}

                            {data.customSocial && data.customSocial !== false && data.customSocial.trim() !== "" && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Your {data.customSocial} User Name</label>
                                    <div className="control">
                                        <input className="input " type="text" name="AuthCustomSocial" placeholder="User Name" value={formData.customSocial} onChange={handleFormChange} required />
                                    </div>
                                </div>
                            )}

                            {data.customMarketPlaceName && data.customMarketPlaceName !== false && data.customMarketPlaceName.trim() !== "" && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>{data.customMarketPlaceName} Account Name</label>
                                    <div className="control">
                                        <input className="input " type="text" name="customMarketPlaceName" placeholder="Account Name" value={formData.customMarketPlaceName} onChange={handleFormChange} required />
                                    </div>
                                </div>
                            )}

                            {data.customForoum && data.customForoum !== false && data.customForoum.trim() !== "" && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>{data.customForoum} Profile Link</label>
                                    <div className="control">
                                        <input className="input " type="text" name="customForoum" placeholder="Profile Link" value={formData.customForoum} onChange={handleFormChange} required />
                                    </div>
                                </div>
                            )}
                            {data.email && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Email</label>
                                    <div className="control">
                                        <input className="input " type="text" name="email" placeholder="Email" value={formData.email} onChange={handleFormChange} required />
                                    </div>
                                    {formData.email && !hasValEmail && (
                                        <div>
                                            <small
                                                className={`ml-1 mt-1  ${!hasValNumber && formData.email !== '' ? 'has-text-danger' : 'has-text-success'}`}>
                                                {!hasValNumber && formData.email !== '' ? 'Please Enter valid Email Id' : ''}
                                            </small>
                                        </div>
                                    )}
                                </div>
                            )}


                            {data.Phone === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "raleway", fontWeight: "600", fontSize: "13px", height: "23px" }}>Your Phone Number</label>
                                    <div className="control">
                                        <input className="input " type="text" name="Phone" placeholder="9999999999" value={formData.Phone} onChange={handleFormChange} required />
                                    </div>
                                    {formData.Phone && !hasValNumber && (
                                        <small className="has-text-danger">Please Enter valid Mobile number</small>
                                    )}
                                </div>
                            )}

                            {data.whatsapp === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "raleway", fontWeight: "600", fontSize: "13px", height: "23px" }}>Your Whatsapp Number</label>
                                    <div className="control">
                                        <input className="input " type="text" name="whatsapp" placeholder="9999999999" value={formData.whatsapp} onChange={handleFormChange} required />
                                    </div>
                                    {formData.whatsapp && !hasValWhatsapp && (
                                        <small className="has-text-danger">Please Enter valid Whatsapp Number</small>
                                    )}
                                </div>
                            )}

                            {data.gender === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "raleway", fontWeight: "600", fontSize: "13px", height: "23px" }}>Your Gender</label>
                                    <div className="control">
                                        <label className="radio">
                                            <input type="radio" name="gender" value="male" checked={formData.gender === 'male'} onChange={handleFormChange} required /> Male
                                        </label>
                                        <label className="radio">
                                            <input type="radio" name="gender" value="female" checked={formData.gender === 'female'} onChange={handleFormChange} /> Female
                                        </label>
                                        <label className="radio">
                                            <input type="radio" name="gender" value="other" checked={formData.gender === 'other'} onChange={handleFormChange} /> Other
                                        </label>
                                    </div>
                                </div>
                            )}

                            {data.langaugeSpeek === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "raleway", fontWeight: "600", fontSize: "13px", height: "23px" }}>Which language can you write?</label>
                                    <div className="control">
                                        <Select
                                            isMulti
                                            value={formData.langaugeSpeek}
                                            name="langaugeSpeek"
                                            onChange={(selectedOptions) => handleFormChange(selectedOptions, { name: 'langaugeSpeek' })}
                                            options={languageOptions}
                                            className="basic-multi-select "
                                            classNamePrefix="select"
                                            styles={customStyles1}
                                        />
                                    </div>
                                </div>
                            )}
                            {data.langaugeWrite === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "raleway", fontWeight: "600", fontSize: "13px", height: "23px" }}>Which language can you write?</label>
                                    <div className="control">
                                        <Select
                                            isMulti
                                            value={formData.langaugeWrite}
                                            name="langaugeSpeek"
                                            onChange={(selectedOptions) => handleFormChange(selectedOptions, { name: 'langaugeWrite' })}
                                            options={languageOptions}
                                            className="basic-multi-select "
                                            classNamePrefix="select"
                                            styles={customStyles1}
                                        />
                                    </div>
                                </div>
                            )}
                            {data.order && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Order Id</label>
                                    <div className="control">
                                        <input className="input " type="text" name="order" placeholder="Order Id" value={formData.order} onChange={handleFormChange} maxLength={12} required />
                                    </div>
                                    {formData.order && !validOrderId && (
                                        <div>
                                            <small
                                                className={`ml-1 mt-1  ${!validOrderId && formData.order !== '' ? 'has-text-danger' : 'has-text-success'}`}>
                                                {!validOrderId && formData.order !== '' ? 'Enter Valid order id without _,-,@' : ''}
                                            </small>
                                        </div>
                                    )}
                                </div>
                            )}
                            {data.date === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Order Date</label>
                                    <div className="control">
                                        <input className="input " type="date" name="date" placeholder="dd-mm-yyyy" value={formData.date} onChange={handleFormChange} required />
                                    </div>
                                    <p className="help">Please enter the date in the format dd/mm/yyyy.</p>
                                </div>
                            )}
                            {data.submitedDate && data.submitedDate !== false && data.submitedDate.trim() !== "" && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>{data.submitedDate} Submission Date</label>
                                    <div className="control">
                                        <input className="input " type="date" name="submitedDate" placeholder={`Hint: ${data.submitedDate}`} value={formData.submitedDate} onChange={handleFormChange} required />
                                    </div>
                                    <p className="help">Please enter the date in the format dd/mm/yyyy.</p>
                                </div>
                            )}
                           

                            {/* Student Checkbox */}
                            {data.student === true && (
                                <div className="field1" >
                                    <label className="checkbox" style={{ fontFamily: "raleway", fontWeight: "600", fontSize: "13px", height: "23px" }}>
                                        <input
                                            type="checkbox"
                                            checked={formData.student || false}  // Bind checkbox to formData
                                            onChange={(e) => setFormData({ ...formData, student: e.target.checked })}
                                        //required
                                        />
                                        Are you a Student?
                                    </label>
                                </div>
                            )}

                            {/* Conditionally render College Name input if student is true and data.college is true */}
                            {formData.student && data.college === true && (
                                <div className="field1" >
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>What is your College Name?</label>
                                    <div className="control">
                                        <input className="input " type="text" name="collegeName" placeholder="College Name" value={formData.collegeName} onChange={handleFormChange} maxLength={70} required />
                                    </div>
                                    {errors.collegeName && (
                                        <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                            {errors.collegeName}
                                        </p>
                                    )}
                                </div>
                            )}
                            {data.city === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>City</label>
                                    <div className="control">
                                        <input className="input " type="text" name="city" placeholder="City" value={formData.city} onChange={handleFormChange} maxLength={30} required />
                                    </div>
                                    {errors.city && (
                                        <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                            {errors.city}
                                        </p>
                                    )}
                                </div>
                            )}
                            {data.state === true && (
                                <div className="field1" >
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>State</label>
                                    <div className="control">
                                        <input className="input " type="text" name="state" placeholder="City" value={formData.state} onChange={handleFormChange} required />
                                    </div>
                                </div>
                            )}
                            {data.pinCode === true && (
                                <div className="field1" >
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}> Pin Code</label>
                                    <div className="control">
                                        <input className="input " type="number" name="pinCode" placeholder="123456" value={formData.pinCode} onChange={handleFormChange} required />
                                        {errors.pinCode && (
                                            <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                                {errors.pinCode}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                            {data.accountNumber === true && (
                                <div className="field1" >
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Bank Account Number</label>
                                    <div className="control">
                                        <input
                                            className="input "
                                            type="text"
                                            name="accountNumber"
                                            placeholder="Bank Account Number"
                                            value={formData.accountNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Only allow digits (0-9)
                                                if (/^\d*$/.test(value)) {
                                                    handleFormChange(e); // update only if valid
                                                }
                                            }}
                                            inputMode="numeric" // brings up numeric keyboard on mobile
                                            maxLength={18} // optional limit
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                            {data.ifsc === true && (
                                <div className="field1" >
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}> Ifsc Code</label>
                                    <div className="control">
                                        <input
                                            className="input "
                                            type="text"
                                            name="ifsc"
                                            placeholder="Ifsc Code"
                                            value={formData.ifsc}
                                            onChange={handleFormChange}
                                            required
                                        />
                                        {errors.ifsc && (
                                            <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                                {errors.ifsc}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                            {data.BeneficiaryName === true && (
                                <div className="field1" >
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}> Beneficiary Name</label>
                                    <div className="control">
                                        <input
                                            className="input "
                                            type="text"
                                            name="BeneficiaryName"
                                            placeholder="Beneficiary Name"
                                            value={formData.BeneficiaryName}
                                            onChange={handleFormChange}
                                            pattern="[A-Za-z\s]+" // only allow letter and spaces
                                            required
                                            maxLength={50}
                                        />
                                        {errors.BeneficiaryName && (
                                            <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                {errors.BeneficiaryName}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}
                            {data.BankName === true && (
                                <div className="field1" >
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Bank Name</label>
                                    <div className="control">
                                        <input
                                            className="input "
                                            type="text"
                                            name="BankName"
                                            placeholder="Bank Name"
                                            value={formData.BankName}
                                            onChange={handleFormChange}
                                            required
                                            maxLength={50}
                                        />
                                        {errors.BankName && (
                                            <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                {errors.BankName}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}

                            {data.upi === true && (
                                <div className="field1" >
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>UPI ID</label>
                                    <div className="control">
                                        <input
                                            className="input "
                                            type="text"
                                            name="upi"
                                            placeholder="UPI ID"
                                            value={formData.upi}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>
                                </div>
                            )}


                            <div className="field1" >
                                <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>{data.inputValue}</label>
                                <div className="control">
                                    <input
                                        className="input "
                                        type="text"
                                        name="inputValue"
                                        placeholder="Input Value"
                                        value={formData.inputValue1}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                            </div>

                            {/* {data.submitedDate && data.submitedDate !== false && data.submitedDate.trim() !== "" && (
          <div className='field1'>
            <label className="label">Submited Date {data.submitedDate}</label>
            <div className="control">
              <input
                className="input "
                type="text"
                name="submitedDate"
                placeholder="dd/mm/yyyy"
                value={formData.submitedDate}
                onChange={handleFormChange}
                required
              />
            </div>
          </div>
        )} */}

                            {/* Only render if customMarketPlaceName is true */}

                            {/* Only render if customForoum is true */}
                            <div className="field1" >
                                <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>Select Product</label>
                                <div className="control">
                                    <div className="select is-fullwidth" style={{ width: "100%" }}>
                                        <select

                                        >
                                            <option value="" disabled>Select a product</option>
                                            {products.map((product) => (
                                                <option key={product._id} value={product.productName}>
                                                    {product.productName}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                </div>
                            </div>
                            {/* Quantity Field */}
                            {data.productSS === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>
                                        {data.inputValue1}
                                    </label>
                                    <div className="control">
                                        <input
                                            className="input"
                                            type="number"
                                            name="quantity"
                                            placeholder="Quantity"
                                            value={formData.inputValue1}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Product Amount Field */}
                            {data.productSS === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>
                                        {data.inputValue2}
                                    </label>
                                    <div className="control">
                                        <input
                                            className="input"
                                            type="number"
                                            name="productAmount"
                                            placeholder="Product Amount"
                                            value={formData.productAmount}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                            {data.deliveryCharge && (
                                <div className="field1">
                                    <label
                                        className="label"
                                        style={{
                                            fontFamily: "Roboto",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            height: "23px",
                                        }}
                                    >
                                        {data.deliveryCharge}
                                    </label>
                                    <div className="control">
                                        <input
                                            className="input"
                                            type="text"
                                            name="deliveryCharge"
                                            placeholder="Enter value for Input 4"
                                            value={formData.deliveryCharge}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                            {data.profileType &&
                                data.profileType !== false &&
                                data.profileType.trim() !== "" && (
                                    <div className="field1">
                                        <label
                                            className="label"
                                            style={{
                                                fontFamily: "Roboto",
                                                fontWeight: "600",
                                                fontSize: "13px",
                                                height: "23px",
                                            }}
                                        >
                                            {data.profileType} public/private
                                        </label>
                                        <div className="control">
                                            <input
                                                className="input "
                                                type="text"
                                                name="profileType"
                                                placeholder="profileType"
                                                value={formData.profileType}
                                                onChange={handleFormChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                )}
                            {data.review &&
                                data.review !== false &&
                                data.review.trim() !== "" && (
                                    <div className="field1">
                                        <label
                                            className="label"
                                            style={{
                                                fontFamily: "Roboto",
                                                fontWeight: "600",
                                                fontSize: "13px",
                                                height: "23px",
                                            }}
                                        >
                                            How Many{data.review} Reviews you do per month
                                        </label>
                                        <div className="control">
                                            <input
                                                className="input "
                                                type="number"
                                                name="review"
                                                placeholder="Number of Reviews"
                                                value={formData.review}
                                                onChange={handleFormChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                )}
                            {/* Screenshot Upload Field */}
                            {data.productSS === true && (
                                <div className="field1">
                                    <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "13px", height: "23px" }}>
                                        {data.inputValue3}
                                    </label>
                                    <div className="control">
                                        <input
                                            className="input"
                                            type="file"
                                            name="inputValue3"
                                            accept="image/*"
                                            onChange={handleFileUpload}
                                            required
                                            style={{ borderRadius: "1px" }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Only render if whatsappGroup is true */}

                        {/* Only render if city is true */}
                        {data.whatsappGroup === true && (

                            <div className="field1" style={{ marginTop: "50px", marginLeft: "25px" }}>
                                <label className="label" style={{ fontFamily: "Roboto", fontWeight: "600", fontSize: "12px", height: "23px", }}>Have You Joined <img
                                    src="../images/whatsapp (2).png"
                                    alt="Logo"
                                    style={{ height: "13px", width: "13px", objectFit: "contain" }}
                                /> Whatsapp Group</label>
                                <label className="radio" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
                                    <input
                                        type="radio"
                                        name="whatsappGroup"
                                        value="yes"
                                        checked={formData.whatsappGroup === 'yes'}
                                        onChange={handleFormChange}
                                        required
                                    />
                                    Yes
                                </label>
                                <label className="radio" style={{ marginLeft: "10px", fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
                                    <input
                                        type="radio"
                                        name="whatsappGroup"
                                        value="no"
                                        checked={formData.whatsappGroup === 'no'}
                                        onChange={handleFormChange}
                                    />
                                    No
                                </label>
                            </div>
                        )}
                        <div className="field1 is-small">
                            <label className="checkbox" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", top: "15px", marginLeft: "25px" }}>
                                <input
                                    type="checkbox"
                                    required
                                />
                                Agree to{' '}
                                <a href="//hobo.video/terms-conditions-for-an-influencer" target="_blank" rel="noopener noreferrer" style={{ fontFamily: "Roboto", fontWeight: "500", fontSize: "12px", }}>
                                    Terms and Conditions
                                </a>
                            </label>
                        </div>
                    </div>

                    <button className="button" onClick={handleClearStorage} style={{
                        marginLeft: "1087px", marginTop: "-90px"
                    }} >
                        Clear all
                    </button>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "20px", // space between buttons
                            marginTop: "24px",
                        }}
                    >
                        <button
                            className="button"
                            type="submit"
                            style={{ minWidth: "507px", marginLeft: "30px", marginBottom: "15px" }}
                        >
                            {loading ? <div className="loader"></div> : "Submit"}
                        </button>

                        <button
                            className="button"
                            type="button"
                            onClick={handleCancel} // define this function
                            style={{ minWidth: "507px", marginLeft: "40px", marginBottom: "15px" }}
                        >
                            Cancel
                        </button>
                    </div>


                </form >
                {showMessage && (
                    <div className="thank-you-message">
                        <h1>Form Submited successfully</h1>
                        <p>Thank you for submitting the form!</p>
                    </div>
                )
                }
            </div >

        </>
    );
};

export default AdminForm;
